<template>
  <div>
    <!-- <h4 class="">比重总和：{{ valueTotal }}/{{ dataList.questionDetails.issue.total_value }}</h4> -->
    <h4 v-if="dataList.questionDetails.issue.validate.open">
      加总值需要{{ getConditionText(dataList.questionDetails.issue.validate.operator)
      }}{{ dataList.questionDetails.issue.validate.value || 0 }}
    </h4>
    <p v-if="dataList.questionDetails.issue.showSum">加总值：{{valueTotal}}</p>
    <!-- <div class="matrix-scale" v-for="(rowItem, id) of dataList.questionDetails.issue.items" :key="id">
      <span v-html="transformHtml(rowItem.content.text)"></span>
      <div class="slider-style">
        <el-slider
          show-input
          v-model.number="dataList.items[id].value"
          @input="handleChange($event, dataList, id)"
          input-siz="mini"
        ></el-slider>
      </div> -->

    <div class="matrix-scroll" v-for="(rowItem, id) of dataList.questionDetails.issue.items" :key="id">
      <span v-html="transformHtml(rowItem.content.text)"></span>
      <el-input-number
        v-model="dataList.items[id].value"
        @change="handleChange(dataList, dataList.items[id].optionId)"
        :min="rowItem.min"
        :max="rowItem.max"
        size="mini"
        label="描述文字"
      ></el-input-number>
      <div>
        <el-radio v-if="dataList.questionDetails.issue.showUnknown && isShowUnknown" :value="unknown[rowItem.id]" :label="rowItem.id" @change="changeUnknown(rowItem.id)">
          {{dataList.questionDetails.issue.unknownText}}
        </el-radio>
      </div>
      <div class="slider-style">
        <span style="padding-right: 15px">{{ rowItem.min }}</span>
        <el-slider
          v-model.number="dataList.items[id].value"
          @change="handleChange(dataList, dataList.items[id].optionId)"
          input-size="mini"
          :min="rowItem.min"
          :max="rowItem.max"
        ></el-slider>
        <span style="padding-left: 15px">{{ rowItem.max }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import '../public/style.css'
import { saveArr, getConditionText } from '../public'

export default {
  name: 'MatrixScroll',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      num: 0,
      marks: {},
      isSlider: false,
      min: null,
      max: null,
      leftText: '',
      rightText: '',
      dataList: [],
      isShowUnknown: true
    }
  },
  computed: {
    valueTotal() {
      let total = 0
      this.dataList.items.forEach(element => {
        total += parseInt(element.value)
      })
      return total
    },
    unknown: {
      get() {
        const res = {}
        this.rowData.items.forEach(item => {
          if(!!item.optionId && item.value === ''){
            res[item.optionId] = item.optionId
          }else{
            res[item.optionId] = null
          }
        })
        return res
      },
      set() {

      }
    }
  },
  created() {
    this.dataList = JSON.parse(JSON.stringify(this.rowData))
    this.dataList.items.forEach(element => {
      element.value = Number(element.value)
    })
  },
  mounted() {
    // this.getSliderInfo()
  },
  inject: ['transformHtml'],
  methods: {
    changeUnknown(v){
      this.isShowUnknown = false
      this.unknown[v] = v
      this.isShowUnknown = true
      this.dataList.items.find(item => item.optionId === v).value = 0
      this.handleChange(this.dataList, v, true)
    },
    getConditionText,
    getSliderInfo() {
      // this.dataList.questionDetails.issue.labels.forEach((element, index) => {
      //   this.min = index == 0 ? element.num : this.min
      //   this.max = index == 1 ? element.num : this.max
      //   this.leftText = index == 0 ? element.text : this.leftText
      //   this.rightText = index == 1 ? element.text : this.rightText
      // })
      // this.marks[this.min] = this.min.toString()
      // this.marks[this.max] = this.max.toString()
      // this.isSlider = true
    },
    handleChange(row, id, isChangeUnknown = false) {
      if( !isChangeUnknown ){
        this.isShowUnknown = false
        this.$set(this.unknown, id, null)
        this.isShowUnknown = true
      }
      let data = JSON.parse(JSON.stringify(this.dataList))
      data.items.forEach(item => {
        if(this.unknown[item.optionId] === item.optionId){
          item.value = ''
        }
      })
      let ids = this.saveArr(data)
      if (ids !== -1) {
        this.updateArr.splice(ids, 1)
        this.updateArr.push(row)
      }
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped>
.slider-style {
  width: 100%;
  // height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    max-width: 15%;
    text-align: center;
    padding: 0 5px;
    font-size: 14px;
    color: #606266;
  }
}
::v-deep.el-slider {
  // width: 80%;
  flex: 1;
}
.matrix-scroll > span {
  font-size: 14px;
  margin-right: 10px;
}
::v-deep.el-input__inner {
  width: 100px;
  // margin: 0;
}
::v-deep.el-input-number__decrease {
  width: 20px;
}
::v-deep.el-input-number__increase {
  left: 78px;
  width: 20px;
}
</style>
